import { EnvironmentProviders, Provider } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const translateProviders: Provider[] | EnvironmentProviders = provideTranslateService({
  fallbackLang: 'it',
  loader: provideTranslateHttpLoader({
    prefix: 'assets/i18n/',
    suffix: '.json',
  }),
});
